"use client"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import {
  TIKTOK_CONNECT_NOTICE_POINTS,
  TIKTOK_REGIONAL_LIMITS_URL,
} from "@/lib/agents/messaging/channels/tiktok/regional-notice"
import { useTranslations } from "next-intl"


interface TiktokConnectNoticeDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Opens the TikTok authorization popup. */
  onContinue: () => void
}

/**
 * TikTok's constraints, shown before authorization. Same rationale as the
 * WhatsApp notice: each of these is something a customer discovers as a support
 * ticket if they meet it after connecting rather than before.
 */
export function TiktokConnectNoticeDialog({
  open,
  onOpenChange,
  onContinue,
}: TiktokConnectNoticeDialogProps) {
  const tUi = useTranslations("Messaging.AgentsMessagingSettingsTiktokConnectNoticeDialog")
  const tCommonUi = useTranslations("Common")

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle><span key={tUi("beforeYouConnectTikTok")}>{tUi("beforeYouConnectTikTok")}</span></DialogTitle>
          <DialogDescription>
            <span key={tUi("tikTokLimitsWhichAccountsAndWhichAudiencesTheir")}>{tUi("tikTokLimitsWhichAccountsAndWhichAudiencesTheir")}</span></DialogDescription>
        </DialogHeader>

        <ul className="space-y-3 text-sm text-gray-600">
          {TIKTOK_CONNECT_NOTICE_POINTS.map((point) => (
            <li key={point.title}>
              <span className="font-medium text-gray-900">{point.title}</span> {point.body}
            </li>
          ))}
        </ul>

        <p className="text-xs text-gray-500">
          <a
            href={TIKTOK_REGIONAL_LIMITS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            <span key={tUi("tikTokSRegionalAvailabilityDocumentation")}>{tUi("tikTokSRegionalAvailabilityDocumentation")}</span></a>
        </p>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            <span key={tCommonUi("cancel")}>{tCommonUi("cancel")}</span></Button>
          <Button onClick={onContinue}><span key={tUi("continue")}>{tUi("continue")}</span></Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
